import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Chip,
} from "@mui/material";
import { formatDate } from "../../Components/formatDate";

function formatCurrency(value) {
  return Number(value || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

function MetaItem({ label, value }) {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "160px 1fr",
        gap: 1.25,
        alignItems: "start",
        py: 1.1,
        borderBottom: "1px dashed #dce7ee",
      }}
    >
      <Typography
        variant="caption"
        sx={{
          color: "#5d7385",
          fontWeight: 700,
          letterSpacing: 0.2,
          textTransform: "uppercase",
        }}
      >
        {label}
      </Typography>
      <Typography
        variant="body2"
        sx={{ color: "#11263a", fontWeight: 600, wordBreak: "break-word" }}
      >
        {value ?? "-"}
      </Typography>
    </Box>
  );
}

function SectionCard({ title, children }) {
  return (
    <Box
      sx={{
        p: 2.25,
        borderRadius: 3,
        border: "1px solid #dce8ef",
        backgroundColor: "#ffffff",
        boxShadow: "0 2px 8px rgba(12, 35, 64, 0.05)",
      }}
    >
      <Typography
        variant="subtitle2"
        sx={{
          color: "#1e5560",
          fontWeight: 800,
          mb: 1.5,
          letterSpacing: 0.2,
          textTransform: "uppercase",
          fontSize: "0.76rem",
        }}
      >
        {title}
      </Typography>
      {children}
    </Box>
  );
}

export default function ReceivablesViewModal({ show, onHide, data }) {
  const paymentStatusPaid = !(data?.PaymentOptions === 0 || data?.PaymentOptions === "0");
  const receivableYear =
    data?.FiscalYear ||
    data?.Year ||
    (data?.Date ? new Date(data.Date).getFullYear() : null);
  const rawInvoiceNr = data?.InvoiceNr != null ? String(data.InvoiceNr).trim() : "";
  const receivableNumberDisplay = rawInvoiceNr
    ? rawInvoiceNr.toUpperCase().startsWith("REC-")
      ? rawInvoiceNr
      : receivableYear
        ? `REC-${receivableYear}-${rawInvoiceNr}`
        : `REC-${rawInvoiceNr}`
    : "-";

  return (
    <Dialog
      open={show}
      onClose={onHide}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 4,
          overflow: "hidden",
          background: "#f3f8fb",
        },
      }}
    >
      <Box
        sx={{
          px: 3.5,
          py: 2.75,
          background: "linear-gradient(135deg, #15324b 0%, #24605c 100%)",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
          flexWrap: "wrap",
        }}
      >
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 800, lineHeight: 1.2, mb: 0.4 }}>
            {data?.InvoiceNr ? `Detajet e Arkëtimit #${data.InvoiceNr}` : "Detajet e Arkëtimit"}
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.9 }}>
            Shikim i të dhënave pa mundësi ndryshimi
          </Typography>
        </Box>

        <Chip
          label={paymentStatusPaid ? "Arkëtuar" : "Pa Arkëtim"}
          color={paymentStatusPaid ? "success" : "warning"}
          variant="filled"
          sx={{ fontWeight: 800 }}
        />
      </Box>

      <DialogContent dividers sx={{ p: 3.5, backgroundColor: "#f3f8fb" }}>
        <Box sx={{ display: "grid", gap: 2 }}>
          <SectionCard title="Detajet Kryesore">
            <MetaItem label="Numri i Arkëtimit / Viti" value={receivableNumberDisplay} />
            <MetaItem label="Data" value={data?.Date ? formatDate(data.Date) : "-"} />
            <MetaItem label="Klienti" value={data?.Account?.AccountName ?? data?.AccountName ?? "-"} />
            <MetaItem label="Vlera" value={`${formatCurrency(data?.Total)} EUR`} />
            <MetaItem label="Komenti" value={data?.Coment || "-"} />
          </SectionCard>

          <SectionCard title="Kontabiliteti">
            <MetaItem label="Llogaria Kontabël" value={data?.LedgerID || "-"} />
            <MetaItem label="Statusi" value={paymentStatusPaid ? "Arkëtuar" : "Pa Arkëtim"} />
          </SectionCard>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2.25, backgroundColor: "#eef4f8" }}>
        <Button onClick={onHide} color="inherit" sx={{ fontWeight: 700 }}>
          Mbyll
        </Button>
      </DialogActions>
    </Dialog>
  );
}
